import WsRpc from '../lib/wsrpc';
import $ from 'jquery';

export function createConnection(token = null) {

    if (!window.RNIS_SETTINGS) {
        $.ajax({
            dataType: 'json',
            url: `${window.location.origin}/static/settings/settings.json`,
            async: false,
            success: function(data){window.RNIS_SETTINGS = data}
        });
    }

    let wsProtocol = App.isSecure ? 'wss://' : 'ws://';
    let ajaxProtocol = App.isSecure ? 'https://' : 'http://';

    if (window.RNIS_SETTINGS.isHTTP) {
        wsProtocol = 'ws://';
        ajaxProtocol  = 'http://';
    }

    const wsUrl = `${wsProtocol}${getHostName('ws')}`;
    const ajaxUrl = `${ajaxProtocol}${getHostName('ajax')}`;

    return new WsRpc({
        token,
        ws: {
            url: wsUrl,
            realm: 'default',
            max_retries: App.ws.max_retries,
            max_retry_delay: App.ws.max_retry_delay
        },

        ajax: {
            url: ajaxUrl,
            retry_timeout: 5
        }
    });
}

export const getHostName = (protocol) => {
    return window.RNIS_SETTINGS.RNIS_API_URL + App[protocol].uri;
};





// WEBPACK FOOTER //
// ./src/helpers/wsrpc.js